var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticClass:"video-js",class:_vm.getPlayerProgressbarClass,style:(_vm.isUploadWindow?'width:600px;height:100%':''),attrs:{"id":_vm.playerId,"crossorigin":"anonymous"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }